import { isAndroidApp } from "@/utils/pwaContext";

/**
 * Nouveau modèle (16/08/2026) : 1 musique = 9,99 € tout compris (tarif 20/08/2026). Règle devise DÉFINITIVE
 * (décision admin) : langue FR -> €, langue EN -> $. Sur l'app Android (TWA), aucun prix ne
 * doit être affiché (la fenêtre Google Play Billing montre le prix localisé du pays).
 * Le système de jetons est conservé en interne mais n'est plus jamais affiché.
 */
export function formatPrice(amount, language) {
  const v = Number(amount) || 0;
  return language === "fr" ? `${v.toFixed(2).replace(".", ",")} €` : `$${v.toFixed(2)}`;
}

export function formatPriceWithSign(amount, language) {
  return `+${formatPrice(amount, language)}`;
}

export const SONG_PRICE = { fr: "9,99 €", en: "$9.99" };
export const SONG_UNIT_PRICE_EUR = 9.99;

export function songPriceLabel(language) {
  return language === "fr" ? SONG_PRICE.fr : SONG_PRICE.en;
}

export { isAndroidApp };
